import { FC } from 'react'
import { UserFull } from '@wellesley/openapi'
import { useSetLastApp } from '@wellesley/apps'
import { useIsItemActive } from '../hooks/useIsItemActive'
import { getGroupChannelPath } from '@wellesley/group'
import { Item } from '../Item'
import { ChannelAvatar } from './ChannelAvatar'

type AppListSize = 'sm' | 'lg'
type ChannelItemProps = {
  channel: UserFull
  size: AppListSize
  groupName: string
}

export const ChannelItem: FC<ChannelItemProps> = ({
  channel,
  size,
  groupName,
}) => {
  const link = getGroupChannelPath({
    groupName,
    channel: { groupUserName: channel.groupUserName },
  })

  const isActive = useIsItemActive(link)

  useSetLastApp({ link, groupname: groupName, isActive })

  return (
    <Item
      title={channel.displayName}
      link={link}
      size={size}
      isActive={isActive}
    >
      <ChannelAvatar image={channel.avatar} name={channel.displayName} />
    </Item>
  )
}
